import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MsalInterceptor } from '@azure/msal-angular';

@Injectable()
export class BackendAPIInterceptor
  extends MsalInterceptor
  implements HttpInterceptor{
  override intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return super.intercept(req, next);
  }
}
